function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-shapes");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-shapes",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5,16 C10.9852814,16 13,18.0147186 13,20.5 C13,22.9852814 10.9852814,25 8.5,25 C6.01471863,25 4,22.9852814 4,20.5 C4,18.0147186 6.01471863,16 8.5,16 Z M25.3333333,16.5 L23,20.5 L26,24.5 L17,24.5 L19,16.5 L25.3333333,16.5 Z M19.5,4.5 L19.5,12.5 L11.5,12.5 L11.5,4.5 L19.5,4.5 Z",
  id: "Combined-Shape"
})));

const SvgIco30Shapes = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Shapes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-shapes.d7f7687d.svg";
export { ForwardRef as ReactComponent };